/* global axios */
import ApiClient from '../ApiClient';

// T-149: os dez indicadores da operação no período, por canal e Bira × humano.
class VisaoGeralAPI extends ApiClient {
  constructor() {
    super('fandata/visao_geral', { accountScoped: true });
  }

  // T-252: `inboxId` e `lado` são opcionais; ausentes, a tela mede a operação inteira.
  get({ since, until, inboxId, lado } = {}) {
    return axios.get(this.url, {
      params: { since, until, inbox_id: inboxId, lado },
    });
  }

  // T-170: as conversas por trás de um indicador, no MESMO período da tela.
  conversas({ indicador, since, until, inboxId, lado } = {}) {
    return axios.get(`${this.url}/conversas`, {
      params: { indicador, since, until, inbox_id: inboxId, lado },
    });
  }
}

export default new VisaoGeralAPI();
